<template>
  <!-- 210304 | id 추가 -->
  <section
    id="about"
    class="about"
  >
    <ul class="about__row">
      <li class="about__left about__left--type01">
        <div class="about__txtBox">
          <h2 class="title">
            프로젝트 전담 매니저와<br>엔지니어의 효율적인 업무 분담 체계
          </h2>
          <p class="description description--about">
            생산성 향상과 보다 높은 업무 효율을 위해 프로젝트 별 전담 매니저와 세부 업무별 전문 엔지니어들의 분업 체계를 구축하여 프로젝트를 진행 합니다.
          </p>
        </div>
      </li>
      <li class="about__right">
        <div class="about__imgBox about__share">
          <img
            class="about__share--img01"
            src="@/assets/images/people01.png"
          >
          <img
            class="about__share--img02"
            src="@/assets/images/people02.png"
          >
          <img
            class="about__share--img03"
            src="@/assets/images/people03.png"
          >
          <img
            class="about__share--img04"
            src="@/assets/images/stick01.png"
          >
          <img
            class="about__share--img05"
            src="@/assets/images/stick02.png"
          >
          <img
            class="about__share--img06"
            src="@/assets/images/stickcircle01.png"
          >
          <img
            class="about__share--img07"
            src="@/assets/images/stickcircle02.png"
          >
          <img
            class="about__share--img08"
            src="@/assets/images/stickcircle03.png"
          >
        </div>
      </li>
    </ul>
    <ul class="about__row">
      <li class="about__left">
        <div class="about__imgBox about__browser">
          <img
            class="about__browser--img01"
            src="@/assets/images/browser01.png"
          >
          <img
            class="about__browser--img02"
            src="@/assets/images/browser02.png"
          >
          <img
            class="about__browser--img03"
            src="@/assets/images/browser03.png"
          >
          <img
            class="about__browser--img04"
            src="@/assets/images/browser04.png"
          >
          <img
            class="about__browser--img05"
            src="@/assets/images/browser05.png"
          >
          <img
            class="about__browser--img06"
            src="@/assets/images/browser06.png"
          >
          <img
            class="about__browser--img07"
            src="@/assets/images/browser07.png"
          >
          <img
            class="about__browser--img08"
            src="@/assets/images/browser08.png"
          >
          <img
            class="about__browser--steam"
            src="@/assets/images/browser_steam.png"
          >
        </div>
      </li>
      <li class="about__right">
        <div class="about__txtBox  about__txtBox--type02">
          <h2 class="title">
            다양한 장치와 브라우저 환경에서<br> 저희가 먼저 테스트 합니다
          </h2>
          <p class="description description--about">
            Window, Mac, IOS, Android 등 다양한 OS환경과 Chrome, Safari등 다양한 브라우저 환경에서 동작할 수 있도록 선제적 테스트를 진행 합니다
          </p>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
	name: 'Feature'
}
</script>

<style lang="scss" scoped>
.about{
  $self:&;
  width:1000px;
  margin:0 auto;
  padding:95px 0 107px 0;
  &__row{
    &:after{
      display:block;
      content:'';
      clear:both;
    }
    &:not(:first-child){
      padding-top:76px;
    }
  }
  &__left{
    float:left;
    width:45%;
    margin-right:50px;
    &--type01{
      margin-right:38px;
    }
  }
  &__txtBox{
    padding:78px 0 77px;
    &--type02{
      padding:74px 30px 55px 0px;
    }
  }
  &__right{
    float:left;
    width:50%;
  }
  &__imgBox {
    position: relative;
  }
  &__img{
    width:450px;
    height:320px;
  }
  &__share {
    width:450px;
    height:320px;
    background:url('~@/assets/images/circle.png') no-repeat 0 0;
    background-size:450px 320px;
    img {
      position:absolute;
    }
    &--img01 {
      width:134px;
      height:158px;
      z-index: 3;
      left:315px;
      top:143px;
    }
    &--img02 {
      width:135px;
      height:134px;
      z-index: 3;
      left:232px;
      top:11px;
    }
    &--img03 {
      width:154px;
      height:135px;
      z-index: 3;
      left:10px;
      top:140px;
    }
    &--img04 {
      width:75px;
      height:100px;
      z-index: 2;
      left:292px;
      top:89px;
    }
    &--img05 {
      width:223px;
      height:137px;
      z-index: 2;
      left:89px;
      top:63px;
    }
    &--img06 {
      width:145px;
      height:65px;
      z-index: 1;
      left:291px;
      top:14px;
    }
    &--img07 {
      width:147px;
      height:94px;
      z-index: 1;
      left:58px;
      top:215px;
    }
    &--img08 {
      width:67px;
      height:134px;
      z-index: 1;
      left:0px;
      top:75px;
    }
  }
  &__browser {
    width:450px;
    height:320px;
    background:url('~@/assets/images/browser_back.png') no-repeat 0 0;
    background-size:450px 320px;
    img {
      position:absolute;
    }
    &--img01 {
      width:49px;
      height:49px;
      left:122px;
      top:161px;
      z-index: 2;
    }
    &--img02 {
      width:68px;
      height:68px;
      left:38px;
      top:126px;
      z-index: 2;
    }
    &--img03 {
      width:49px;
      height:49px;
      left:35px;
      top:60px;
      z-index: 2;
    }
    &--img04 {
      width:48px;
      height:48px;
      left:107px;
      top:93px;
      z-index: 2;
    }
    &--img05 {
      width:68px;
      height:68px;
      left:169px;
      top:64px;
      z-index: 2;
    }
    &--img06 {
      width:48px;
      height:48px;
      left:279px;
      top:69px;
      z-index: 2;
    }
    &--img07 {
      width:68px;
      height:68px;
      left:103px;
      top:0px;
      z-index: 2;
    }
    &--img08 {
      width:48px;
      height:48px;
      left:213px;
      top:12px;
      z-index: 2;
    }
    &--steam {
      width:53px;
      height:19px;
      left:215px;
      top:176px;
      z-index: 2;
    }
  }
}

.about__share--img01,.about__share--img08 {
  animation: flicker 10s ease alternate infinite;
}
.about__share--img02,.about__share--img07 {
  animation: flicker 8s ease alternate infinite;
}
.about__share--img03,.about__share--img06 {
  animation: flicker 9s ease alternate infinite;
}

.about__browser--img01 {
  animation: flicker2 8s ease alternate infinite;
}
.about__browser--img02 {
  animation: flicker2 9s ease alternate infinite;
}
.about__browser--img03 {
  animation: flicker2 10s ease alternate infinite;
}
.about__browser--img04 {
  animation: flicker2 11s ease alternate infinite;
}
.about__browser--img05 {
  animation: flicker2 11.5s ease alternate infinite;
}
.about__browser--img06 {
  animation: flicker2 10.5s ease alternate infinite;
}
.about__browser--img07 {
  animation: flicker2 9.5s ease alternate infinite;
}
.about__browser--img08 {
  animation: flicker2 8.5s ease alternate infinite;
}
.about__browser--steam {
  animation: flicker3 8.5s ease alternate infinite;
}

@keyframes flicker {
  0% {
    transform: translateX(5px) translateY(10px) rotate(0)
  } 50% {
    transform: translateX(10px) translateY(15px) rotate(5deg);
  } 100% {
    transform: translateX(5px) translateY(10px) rotate(0);
  }
}
@keyframes flicker2 {
  0% {
    transform: scale(0)
  } 10% {
    transform: scale(1)
  } 80% {
    transform: scale(1)
  } 100% {
    transform: scale(0)
  }
}
@keyframes flicker3 {
  0% {
    transform: scale(1.5, 1)
  } 50% {
    transform: scale(2, 1)
  } 100% {
    transform: scale(1.5, 1)
  }
}
</style>